import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import Logo from "./Logo";
import { LOGO_URL } from "@/data";

export default function Footer({ onAdmin, onCreator }) {
  const [login, setLogin] = useState(null);

  return (
    <footer className="mt-20 border-t border-gold/10 px-6 py-7 text-center">
      <span className="mx-auto flex h-11 w-max items-center rounded-lg bg-alpana px-2.5">
        <img src={LOGO_URL} alt="রং ও মাটি" className="h-8 w-auto object-contain no-night" />
      </span>
      <p className="mt-3 text-[11px] tracking-wide text-sand/40">
        রং ও মাটি • বাংলার ডিজিটাল সাংস্কৃতিক গ্রাম — প্রথম প্রোটোটাইপ
      </p>
      <p className="mt-2.5 flex items-center justify-center gap-3 text-[11px] text-sand/45">
        <button
          data-testid="footer-link-creator"
          onClick={() => (onCreator ? onCreator() : setLogin("creator"))}
          className="underline-offset-4 transition-colors hover:text-gold hover:underline"
        >
          Creator Login
        </button>
        <span className="text-sand/25">|</span>
        <button
          data-testid="footer-link-admin"
          onClick={() => (onAdmin ? onAdmin() : setLogin("admin"))}
          className="underline-offset-4 transition-colors hover:text-gold hover:underline"
        >
          Admin Login
        </button>
      </p>

      <AnimatePresence>
        {login && (
          <motion.div
            className="fixed inset-0 z-[95] flex items-center justify-center bg-dusk/80 p-6 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setLogin(null)}
          >
            <motion.div
              initial={{ opacity: 0, y: 18, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 12, scale: 0.98 }}
              transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="relative w-full max-w-sm rounded-2xl border border-gold/25 bg-plaster p-8 text-center shadow-2xl"
              onClick={(e) => e.stopPropagation()}
              data-testid="login-placeholder-modal"
            >
              <button
                data-testid="login-placeholder-close"
                onClick={() => setLogin(null)}
                className="absolute right-4 top-4 rounded-full p-1.5 text-sand/50 transition-colors hover:bg-sand/10 hover:text-sand"
                aria-label="বন্ধ করুন"
              >
                <X size={16} />
              </button>
              <Logo className="mx-auto h-10 w-10" />
              <h3 className="mt-4 font-display text-xl text-sand">
                {login === "creator" ? "Creator Login" : "Admin Login"}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-sand/60">
                প্রোটোটাইপ পর্বে এই লগইন এখনো খোলা হয়নি — গ্রাম তৈরি হওয়ার সঙ্গে সঙ্গে আসছে।
              </p>
              <p className="mt-1 font-latin text-xs italic text-gold/60">Coming soon in this prototype</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </footer>
  );
}
